export const MODULE_LABELS = {
  habitat_99: 'Habitat 99',
};

export const CHANNEL_LABELS = {
  internal_panel: 'Sistema',
  mobile_push: 'App mobile',
  email: 'Email',
};

export const STATUS_LABELS = {
  new: 'Nueva',
  read: 'Leída',
  resolved: 'Resuelta',
  suppressed: 'Suprimida',
  failed: 'Fallida',
  success: 'Exitosa',
  running: 'En curso',
  dry_run: 'Dry-run',
  pending: 'Pendiente',
  sent: 'Enviada',
  queued: 'En cola',
  blocked_non_production: 'Bloqueado fuera de prod.',
  suppressed_no_token: 'Sin token',
  suppressed_module_unavailable: 'Sin módulo mobile',
  blocked: 'Bloqueada',
  ok: 'OK',
  warning: 'Atención',
};

export const STATUS_PRESETS = {
  new: { status: 'warning' },
  read: { status: 'info' },
  resolved: { status: 'success' },
  suppressed: { status: 'neutral' },
  failed: { status: 'error' },
  success: { status: 'success' },
  running: { status: 'warning' },
  dry_run: { status: 'info' },
  pending: { status: 'warning' },
  sent: { status: 'success' },
  queued: { status: 'warning' },
  blocked_non_production: { status: 'neutral' },
  suppressed_no_token: { status: 'neutral' },
  suppressed_module_unavailable: { status: 'neutral' },
  blocked: { status: 'neutral' },
  ok: { status: 'success' },
  warning: { status: 'warning' },
};

export const COMPLETED_PROJECT_TYPE = 'completed_project_contracts_missing_operational_data';
export const COUPON_DUE_TYPE = 'coupon_due_tomorrow';
export const COUPON_COLLECTION_TYPE = 'coupon_collection_by_due';

export const DEFAULT_FILTERS = {
  target_app_module: 'habitat_99',
  status: 'all',
  notification_type: 'all',
  severity: 'all',
  is_urgent: 'all',
  contract_number: '',
  recipient: '',
  date_from: '',
  date_to: '',
  search: '',
};
